document.querySelector('.pageTop').addEventListener('click', function () {
  document.querySelector('.center').scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});